import {Component, OnInit, OnDestroy} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {LotteriesService} from '../lotteries.service';
import * as globals from '../settings';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {CounterService} from '../_services/counter.service';
import {TimeService} from '../_services/time.service';
import {IncomingdrawsService} from '../_services/incomingdraws.service';
import {CurrencyService} from '../_services/currency.service';
import {JackpotConfigService} from '../_services/jackpotConfig.service';
import {JsontranslateService} from "../_services/jsontranslate.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-carousel-winners',
  templateUrl: './carousel-winners.component.html',
  styleUrls: ['./carousel-winners.component.scss']
})
export class CarouselWinnersComponent implements OnInit, OnDestroy {
  desktop: any;
  itemsArr: any;
  itemsSize: number;
  nav: true;
  languageChange: Subscription;
  showLang: any;
  priceName: any;
  xx: any;
  changedCurrency: Subscription;
  currency: any;
  done: any;

  constructor(private lotteriesService: LotteriesService, public subscriptionsService: SubscriptionsService,
              public counterService: CounterService, public timeService: TimeService,
              public incomingDrawsService: IncomingdrawsService,
              public currencyService: CurrencyService,
              public jackpotConfig: JackpotConfigService,
              private jsontranslate: JsontranslateService,
              private translate: TranslateService) {
    this.done = false;
    this.getItems();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.jsontranslate.loadTranslations('LotteriesWinnersComponent', this.translate.currentLang);
    });

    this.currency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.currency = currency;
      }
    });

    setTimeout(() => {
      this.done = true;
    }, 1500)
  }

  ngOnDestroy() {
    if (this.languageChange) {
      this.languageChange.unsubscribe();
    }
    if (this.changedCurrency) {
      this.changedCurrency.unsubscribe();
    }
  }

  ngOnInit() {
  }

  async getWinners() {
    await fetch(globals.appDomain + '/lotteryWinners/getWinners/winners.json')
      .then(response => response.json())
      .then(data => {
        this.itemsArr = data;
        this.itemsSize = data.length;
      });
  }

  getItems() {
    if (!this.itemsSize) {
      this.getWinners()
    } else {
      setTimeout(() => {
        this.getItems();
      }, 400);
    }
  }

  valueOfIndex(i, v) {
    return this.itemsArr[i][v];
  }

  counter(i: number) {
    return new Array(i);
  }

}
